// jwt.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, BehaviorSubject, throwError, from } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<string | null>(null);

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.authService.getIdToken();
    let authReq = req;

    if (token) {
      authReq = this.addToken(req, token);
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          //return this.handle401Error(authReq, next);
        }
        return throwError(() => error);
      })
    );
  }

  private addToken(req: HttpRequest<any>, token: string) {
    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  // private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  //   if (!this.isRefreshing) {
  //     this.isRefreshing = true;
  //     this.refreshTokenSubject.next(null);

  //     return from(this.authService.getRefreshToken()).pipe(
  //       switchMap((user) => {
  //         this.isRefreshing = false;

  //         const newToken = user?.access_token;

  //         if (!newToken) {
  //           throw new Error('No access token after refresh');
  //         }

  //         this.refreshTokenSubject.next(newToken);

  //         return next.handle(this.addToken(req, newToken));
  //       }),
  //       catchError(err => {
  //         this.isRefreshing = false;

  //         // 🔥 fallback → login redirect
  //         this.authService.login();

  //         return throwError(() => err);
  //       })
  //     );

  //   } else {
  //     // 🔁 Queue requests while refresh is in progress
  //     return this.refreshTokenSubject.pipe(
  //       filter(token => token !== null),
  //       take(1),
  //       switchMap(token => next.handle(this.addToken(req, token!)))
  //     );
  //   }
  // }
}